import { forwardRef } from "react";
import { ReactI18NextChild } from "react-i18next";

export interface Props extends React.HTMLAttributes<HTMLParagraphElement> {
  children: ReactI18NextChild | Iterable<ReactI18NextChild>;
  // Set by InputWrapper (flag uxConfirmFixesEnabled): the label becomes a
  // real <label for=…> so a click on it focuses the field. Unset = today's
  // <p>, byte for byte.
  htmlFor?: string;
}

// forwardRef is kept for the component's identity (InputWrapper matches on
// type); the ref was never attached before and still is not - in either
// branch.
export const InputLabel = forwardRef<HTMLParagraphElement, Props>(
  (props, _ref) => {
    const { children, className, htmlFor, ...rest } = props;
    if (htmlFor) {
      return (
        <label
          htmlFor={htmlFor}
          className={`block font-medium capitalize text-xs ${className ?? ""}`}
          {...(rest as React.LabelHTMLAttributes<HTMLLabelElement>)}
        >
          {children}
        </label>
      );
    }
    return (
      <p
        className={`font-medium capitalize text-xs ${className ?? ""}`}
        {...rest}
      >
        {children}
      </p>
    );
  }
);

/** Red asterisk appended to the label of a required field. */
export function RequiredMark() {
  return <span className="ml-0.5 text-red-100">*</span>;
}
